export default __webpack_public_path__ + "static/dispatching-415bbe94583240394ed8311934cfeaa2.png";